<template>
  <div class="axj-wx">
    <div class="axj-wx-top">
      <div class="axj-wx-top-bk" @click="handleToLogin">
        <div class="axj-wx-top-icon">
        </div>
        <div class="axj-wx-top-label" >
          <label>
            返回
          </label>
        </div>
      </div>
      <div class="axj-wx-top-title">
        <label>
          {{title}}
        </label>
      </div>
    </div>
    <div class="axj-wx-body">
      <axj_wx_login
        :appid="wxLoginConfig.AppId"
        :scope="wxLoginConfig.Scope"
        :theme="wxLoginConfig.Theme"
        :self_redirect="wxLoginConfig.SelfRedirect"
        class="body_login_form_ewm_login_top"
        :redirect_uri="encodeURIComponent(wxLoginConfig.RedirectUri)"
        :href="wxLoginConfig.CssBase64Href"
        :state="wxLoginConfig.state"
        @do-bind="handleDoBinding"
        rel="external nofollow"
        @do-login="handleLogin"
      />
    </div>
    <axj-message-prop
      :dialog-show.sync="axjMessagePropData.dialogShow"
      :button-data="axjMessagePropData.buttonData"
      :dialog-message="axjMessagePropData.dialogMessage"
      :dialog-title="axjMessagePropData.dialogTitle"
      :handle-func="axjMessagePropData.handleFunc"
    />
  </div>
</template>

<script>
import commonModels from '@/common/models/common-models'
export default {
  name: "axj-wx",
  props:{
    title:{
      type:String,
      default:"微信扫码登录"
    }
  },
  data(){
    return{
      axjMessagePropData:{
        dialogShow:false,
        buttonData:[
          {
            "label":"去认证",
            "key":"yes",
            "type":""
          },
          {
            "label":"取消",
            "key":"cancel",
            "type":"primary"
          }
        ],
        handleFunc:function (){
        },
        dialogMessage:undefined,
        dialogTitle:"提示"
      },
      wxLoginConfig:{
        AppId:"wx7dd1288d27f109d9",
        Scope:"snsapi_login",
        Theme:"black",
        SelfRedirect:true,
        RedirectUri:"http://www.aixuejie.cn/#/cert",
        CssBase64Href:'data:text/css;base64,LmltcG93ZXJCb3ggLnFyY29kZSB7d2lkdGg6IDE0NXB4O2hlaWd0aDoxNDVweDttYXJnaW46MHB4O3BhZGRpbmc6MHB4fQouaW1wb3dlckJveCAudGl0bGUge2Rpc3BsYXk6IG5vbmU7fQouaW1wb3dlckJveCAuaW5mbyB7ZGlzcGxheTpub25lfQouc3RhdHVzX2ljb24ge2Rpc3BsYXk6IG5vbmV9Ci5pbXBvd2VyQm94IC5zdGF0dXMge3RleHQtYWxpZ246IGNlbnRlcjt9IA==',
        state:"WEB_BODY_DIALOG"
      }
    }
  },
  methods:{
    initUserInfo(){
      this.$api.commonApi.commonIndex.getUserInfo({uuid: this.$store.getters.getLoginInfo.uuid}).then(res => {
        if (res.code == 200) {
          this.userInfo = res.data
          this.$store.dispatch('saveLoginInfo', {
            uuid: this.$store.getters.getLoginInfo.uuid,
            access_token: this.$store.getters.getLoginInfo.access_token,
            refresh_token:this.$store.getters.getLoginInfo.refresh_token,
            userId: res.data.id
          });
          if (this.userInfo.is_third_party == 0) {
            this.$api.axjWebApi.webAuth.QueryMechanismAuths({
              UserId:this.userInfo.id
            }).then(res=>{
              if(res.data==null||res.data.lists.Status==2){
                this.axjMessagePropData.dialogShow=true
                let that=this
                this.axjMessagePropData.handleFunc=function (v) {
                  if(v==='yes'){
                    that.$router.push({
                      path:"/certification"
                    })
                  }else if('cancel'===v){
                    that.axjMessagePropData.dialogShow=false
                  }
                }
                this.axjMessagePropData.dialogMessage="尊敬的 "+this.userInfo.nickname+"，您尚未进行机构用户认证，无法使用机构用户管理平台，是否去认证？"
              }else if (res.data.lists.Status==0){
                this.axjMessagePropData.buttonData=[{
                  "label":"取消",
                  "key":"cancel",
                  "type":"primary"
                }]
                let that=this
                this.axjMessagePropData.handleFunc=function (res) {
                  if(res==='cancel'){
                    that.axjMessagePropData.dialogShow=false
                  }
                }
                this.axjMessagePropData.dialogShow=true
                this.axjMessagePropData.dialogMessage="尊敬的 "+this.userInfo.nickname+"您已于"+commonModels.formatTime(res.data.lists.CreateTime,'Y年M月D日')+"提请机构用户认证，平台会在7个工作日内完成审核，请您耐心等待！"
              }
            })
          }else{
            this.$store.dispatch("saveUser",
              {
                uid:this.userInfo.id,
                uname:this.userInfo.nickname,
                avatar:this.userInfo.avatar,
                extraShowClubUid:this.userInfo.ExtraShowclubUser.id,
                schoolId:this.userInfo.school_id,
                infoUserUid:this.userInfo.InfoUser.id
              })
            this.$router.push({
              path:"/axjMain"
            })
          }
        }
      })
    },
    handleLogin(res){
      if(res.code==200){
        this.initUserInfo();
      }
    },
    handleToLogin(){
      this.$emit("to-login")
    },
    handleDoBinding(unionId){
      this.$emit("do-bind",{wxUnionId:unionId})
    }
  }
}
</script>

<style slot-scope lang="scss">
.axj-wx{
  display: flex;
  flex-flow: column;
  height: 400px;
  .axj-wx-top{
    display: flex;
    justify-content: center;
    align-items: center;
    .axj-wx-top-bk:hover{
      color: #3a8ee6;
      .axj-wx-top-icon{
        border-top-color: #3a8ee6;
        border-left-color: #3a8ee6;
      }
    }
    .axj-wx-top-bk{
      width: 60px;
      margin-left: 2px;
      display: flex;
      align-items: center;
      font-size: 18px;
      color: #8C8C8C;
      z-index: 0;
      cursor: pointer;
      .axj-wx-top-icon{
        width: 12.5px;
        height: 12.5px;
        border-top: 2px solid #8C8C8C;
        border-radius: 2px;
        border-left: 2px solid #8C8C8C;
        transform: rotate(-45deg);
      }
    }
    .axj-wx-top-title{
      flex: 1;
      font-size: 22px;
      display: flex;
      color: #000000;
      margin-left: -65px;
      justify-content: center;
      align-items: center;
      font-family: PingFang SC;
      font-style: normal;
    }
  }
  .axj-wx-body{
    .body_login_form_ewm_login_top{
      width: 150px;
      height: 150px;
      margin-top: 12px;
    }
    display: flex;
    flex: 1;
    padding-bottom: 60px;
    align-items: center;
    justify-content: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/axj-web-certs/components/axj-wx/index.vue